export default __webpack_public_path__ + "static/media/property_803.90c21323.png";